import api from './base/BaseApi';
import { handleApiError } from '@/services/base/handleApiError';
import {
  TRqPasskeyAuthenticationChallenge,
  TRqPasskeyAuthenticationLogin,
  TRqPasskeyRegisterAttestation,
  TRsPasskeyAuthenticationChallenge,
  TRsPasskeyAuthenticationLoginResponse,
  TRsPasskeyCredential,
  TRsRegisterOptions
} from '@/services/types/Passkey';

export const requestAuthenticationChallenge = () =>
  api.post<TRsPasskeyAuthenticationChallenge, TRqPasskeyAuthenticationChallenge>(
    `api/v1/passkey/authenticate/options`,
    {
      phoneNumber: null
    }
  );

export const sendAuthenticationLoginRequest = (challengeResponse: TRqPasskeyAuthenticationLogin) =>
  api.post<TRsPasskeyAuthenticationLoginResponse, TRqPasskeyAuthenticationLogin>(
    `api/v1/passkey/authenticate/web`,
    challengeResponse
  );

export const requestRegistrationOptions = () =>
  api.post<TRsRegisterOptions, null>(`api/v1/passkey/register/options`, null).catch(handleApiError);

export const registerPasskey = (attestation: TRqPasskeyRegisterAttestation) =>
  api
    .post<unknown, TRqPasskeyRegisterAttestation>(`api/v1/passkey/register`, attestation)
    .catch(handleApiError);

export const getPasskeyCredentials = () =>
  api.get<TRsPasskeyCredential[]>(`api/v1/passkey-credentials`).catch(handleApiError);

export const removePasskeyCredential = (credentialId: string) =>
  api
    .delete<unknown, undefined>(`api/v1/passkey-credentials/${credentialId}`)
    .catch(handleApiError);
